import merge from 'lodash.merge';
import { all, call, put, select, takeLeading } from 'redux-saga/effects';
import { Checkout } from 'b2b-apps/shop/checkout/api/Checkout';
import {
  checkoutFulfilled,
  checkoutRejected,
  updateCheckout,
} from 'b2b-apps/shop/checkout/redux/checkout/actionCreators';
import { INIT_CHECKOUT, UPDATE_CHECKOUT } from 'b2b-apps/shop/checkout/redux/checkout/actionTypes';
import { getRequestData } from 'b2b-apps/shop/checkout/redux/checkout/selectors';
import { InitCheckoutAction, UpdateCheckoutAction } from 'b2b-apps/shop/checkout/redux/checkout/types';
import { clearPlaceOrder } from 'b2b-apps/shop/checkout/redux/order/actionCreators';
import { prepareRequestData } from 'b2b-apps/shop/checkout/utils/checkout';
import { getCollectedOrderData } from 'b2b-apps/shop/collectedOrder/redux/selectors';
import { requestApiSaga } from 'b2b-apps/shop/common/redux/api/sagas';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';

function* initCheckoutSaga(
  action: InitCheckoutAction,
): Generator<any, any, any> {
  const collectedOrderData = yield select(getCollectedOrderData);
  const {
    licenseHolder: { licenseHolder },
    references: { order: orderReference, sales: salesReference },
  } = collectedOrderData;

  try {
    const response = yield call(requestApiSaga, Checkout.init());
    const data = response.data;

    yield put(clearPlaceOrder());
    yield put(checkoutFulfilled(merge(data, collectedOrderData)));

    if (licenseHolder || orderReference || salesReference) {
      const requestData = yield select(getRequestData);
      yield put(updateCheckout(data.token, prepareRequestData(requestData)));
    }
  } catch (error: any) {
    yield put(checkoutRejected(parseError(error)));
    yield put(reportError(action.type, error));
  }
}

function* updateCheckoutSaga(
  action: UpdateCheckoutAction,
): Generator<any, any, any> {
  const { checkoutId, data } = action.payload;

  try {
    const response = yield call(
      requestApiSaga,
      Checkout.update(checkoutId, prepareRequestData(data)),
    );
    yield put(checkoutFulfilled(response.data));
  } catch (error: any) {
    yield put(checkoutRejected(parseError(error)));
    yield put(
      reportError(action.type, error, {
        checkoutId,
      }),
    );
  }
}

function* checkoutSaga(): Generator<any, any, any> {
  yield all([
    takeLeading(INIT_CHECKOUT, initCheckoutSaga),
    takeLeading(UPDATE_CHECKOUT, updateCheckoutSaga),
  ]);
}

export {
  checkoutSaga,
  updateCheckoutSaga,
};
